import { queueChecklistAnswerChanges } from 'serviceWorker/services/checklistAnswers/queueChecklistAnswerChanges';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { checklistAnswerContract } from 'shared/domain/checklistAnswer/checklistAnswerContract';

/** Answers checklist answer changes once queued; their outcome follows as an event with the change's `uniqueId`. */
export function serveChecklistAnswerRequests(): ChannelUnsubscribe {
  return channelServer.handle(checklistAnswerContract, queueChecklistAnswerChanges);
}
